var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeepClean1Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49986 15C7.49979 15.1548 7.54287 15.3067 7.62427 15.4384C7.70567 15.5701 7.82217 15.6766 7.9607 15.7458L9.62736 16.5791C9.75444 16.6426 9.89565 16.6726 10.0376 16.6662C10.1795 16.6598 10.3174 16.6172 10.4382 16.5424C10.559 16.4677 10.6588 16.3633 10.7279 16.2392C10.797 16.1151 10.8333 15.9754 10.8332 15.8333V9.99998C10.8334 9.58696 10.9869 9.18873 11.264 8.88248L17.2832 2.22498C17.3911 2.10545 17.462 1.95722 17.4874 1.79822C17.5129 1.63922 17.4917 1.47626 17.4264 1.32904C17.3612 1.18183 17.2547 1.05667 17.1199 0.968689C16.985 0.880714 16.8275 0.833693 16.6665 0.833313H1.66653C1.50537 0.833371 1.34768 0.880159 1.21257 0.96801C1.07746 1.05586 0.97072 1.181 0.905283 1.32828C0.839846 1.47556 0.818518 1.63865 0.843883 1.79781C0.869248 1.95696 0.940218 2.10534 1.0482 2.22498L7.06903 8.88248C7.34614 9.18873 7.49968 9.58696 7.49986 9.99998V15Z",
    stroke: "#155DFC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeepClean1Icon);
export default __webpack_public_path__ + "static/media/keep_clean_1_icon.a9c9a3b5777603e2bb1db33b5f988153.svg";
export { ForwardRef as ReactComponent };